// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1LQNu","title":"InfoRow_title__2T6aJ"};